import type { ErrorCodeValue } from './error-codes';

export class BeangoError extends Error {
  readonly code: ErrorCodeValue;
  readonly status: number;
  readonly detail?: string;

  constructor(code: ErrorCodeValue, status: number, message: string, detail?: string) {
    super(message);
    this.name = 'BeangoError';
    this.code = code;
    this.status = status;
    this.detail = detail;
  }
}
